<template>
  <div class="row">
    <div class="col-5">
      <div class="col-12 p-0">
        <b-card style="background-color: #ccdaf4">
          <div class="row">
            <div class="col-8">
              <h6 class="text-muted">Status Time</h6>
              <h2>{{ statusTime }}</h2>
            </div>
            <div class="col-4">
              <i style="font-size: 5rem" class="fa fa-user bg-gradient-primary"></i>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-12 p-0">
        <b-card style="background-color: #ccdaf4">
          <div class="row">
            <div class="col-8">
              <h6 class="text-muted">Longest Wait Time</h6>
              <h2>{{ dashboardDetail.longestWaitTime }}</h2>
            </div>
            <div class="col-4">
              <i style="font-size: 5rem" class="fa fa-clock-o bg-gradient-primary"></i>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <!-- <div class="col-7">
      <px-card slot="headerAction" class="card-no-border">
        <div class="media">
          <div class="media-body p-4 text-right">
            <h1 class="display-4 m-0 f-w-500">17</h1>
            <h1 class="mt-0 text-muted">Job In Queue</h1>
          </div>
        </div>
        <div class="media">
          <div class="media-body">
            <div class="profit-card">
              <div id="spaline-chart">
                <apexchart
                  height="150"
                  type="area"
                  :options="apexTotalsale.options"
                  :series="apexTotalsale.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </px-card>
    </div> -->
    <div class="col-7 dash-chart">
      <div class="col-12 mb-3">
        <div class="row align-items-center">
          <div class="col-6">
            <div class="card card-box mb-0">
              <div class="row card-body justify-content-between" style="padding: 15px">
                <div class="col-7">
                  <h6 class="text-muted">Agent Status :</h6>
                </div>
                <div class="col-auto">
                  <span><b-badge :variant="statusColor">{{
                status
              }}</b-badge></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-6">
                <b-button id="default-primary" class="btn-gradient-success w-100 px-0" variant="tranpatent"
                  :disabled="isDisabled" @click="onChangeStatus('ready')">Available</b-button>
              </div>
              <div class="col-6">
                <b-button id="default-primary" class="btn-gradient-danger w-100 px-0" variant="tranpatent"
                  :disabled="isDisabled" @click="onChangeStatus('aux')">Aux</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-12 box-col-12 col-md-12">
        <px-card slot="headerAction" class="card-no-border">
          <div class="media">
            <div class="m-4">
              <p v-if='dashboardDetail.countAllQueue.length > 0' class="m-0"
                v-for="(item, itemId) in dashboardDetail.countAllQueue" :key="itemId">
                {{ item && item.name ? item.name : '' }} {{ item && item.jobCount ? `:${item.jobCount}` : '' }}
              </p>
            </div>
            <div class="media-body px-5 pt-5 pb-3 text-right">
              <h1 class="display-4 m-0 f-w-500">
                {{ dashboardDetail.sumCountQueue }}
                <!-- {{ dashboardDetail.countQueue }} -->
              </h1>
              <h1 class="mt-0 text-muted">Job In Queue</h1>
            </div>
          </div>
          <div>
            <div class="media">
              <div class="media-body">
                <div class="profit-card">
                  <div id="spaline-chart">
                    <apexchart style="pointer-events: none" height="120" type="area" :options="apexTotalsale.options"
                      :series="apexTotalsale.series"></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </px-card>
      </div>
    </div>
    <div class="col-12">
      <b-card body-class="p-0">
        <div class="d-flex justify-content-around align-items-center">
          <div v-for="(item, i) in bottomBar" :key="i" class="py-3 row"
            :class="i == 1 ? 'border-right border-left' : ''" style="width: 33%">
            <div class="col text-right pr-0">
              <feather type="bar-chart-2" style="height: 4rem; color: #7366ff" :style="i == 0
                ? 'color:#2971ff'
                : i == 1
                  ? 'color:#7366ff'
                  : 'color:#a76cff'
                "></feather>
            </div>
            <div class="col">
              <h3 class="mb-0 mt-1">{{ item.case }}</h3>
              <h6 class="text-muted">{{ item.status }}</h6>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { requestService } from '../../_services';

export default {
  data() {
    return {
      apexTotalsale: {
        options: {
          chart: {
            type: 'area',
            toolbar: {
              show: false,
            },
          },
          colors: ['#2971FF', '#fff'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 0,
          },
          xaxis: {
            type: 'datetime',
            categories: [
              '2018-09-19T00:00:00.000Z',
              '2018-09-19T01:30:00.000Z',
              '2018-09-19T02:30:00.000Z',
              '2018-09-19T03:30:00.000Z',
              '2018-09-19T04:30:00.000Z',
              '2018-09-19T05:30:00.000Z',
            ],
          },
          yaxis: {
            low: 0,
            offsetX: 0,
            offsetY: 0,
            show: false,
            labels: {
              low: 0,
              offsetX: 0,
              show: false,
            },
            axisBorder: {
              low: 0,
              offsetX: 0,
              show: false,
            },
          },
          fill: {
            type: 'gradient',
            opacity: [1, 0.4, 0.25],
            gradient: {
              shade: 'light',
              type: 'horizontal',
              shadeIntensity: 1,
              gradientToColors: ['#5BADFA', '#2971FF'],
              opacityFrom: [1, 0.4, 0.25],
              opacityTo: [1, 0.4, 0.25],
              stops: [30, 100],
              colorStops: [],
            },
            colors: ['#2971FF', '#2971FF', '#2971FF'],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm',
            },
          },
          legend: {
            show: false,
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: -40,
            },
          },
        },
        series: [
          {
            name: 'series1',
            data: [280, 170, 440, 170, 270, 130],
          },
          {
            name: 'series2',
            data: [150, 500, 300, 250, 420, 350],
          },
          {
            name: 'series3',
            data: [450, 150, 320, 500, 280, 100],
          },
        ],
      },
      bottomBar: [
        {
          case: 0,
          status: 'Opening',
        },
        {
          case: 0,
          status: 'Pending',
        },
        {
          case: 0,
          status: 'Close',
        },
      ],
      dashboardDetail: {
        countQueue: 0,
        longestWaitTime: '00:00:00',
        countOpen: 0,
        countClose: 0,
        countPending: 0,
        countAllQueue: [],
        sumCountQueue: 0,
      },
      statusTime: '00:00:00',
      status: 'AUX',
      statusColor: 'light',
      isDisabled: false,
      allQueue: [],
    };
  },
  async mounted() {
    await this.getAllQueue();
    const self = this;
    this.$root.$on('updateStatus', (data) => {
      self.setUpdateStatus(data);
    });
    this.$root.$on('realtimeStatusTime', (time) => {
      self.setRealtimeStatusTime(time);
    });
    this.$root.$on('realtimeStatusLongTime', (time) => {
      self.setRealtimeStatusLongTime(time);
    });
    this.$root.$on('setRealtimeDashboard', (data) => {
      self.setRealtimeDashboard(data);
    });
    this.$root.$on('realtimeQueue', (data) => {
      self.dashboardDetail.sumCountQueue = data.jobInQueue;
    });
    // this.$root.$on('setRealtimeAllQueues', (data) => {
    //   self.setRealtimeAllQueues(data);
    // });
  },
  beforeDestroy() {
    // this.$root.$off('realtimeQueue', null)
    // this.$root.$off('updateStatus', null)
    // this.$root.$off('realtimeStatusTime', null)
    // this.$root.$off('setRealtimeDashboard', null)
  },
  methods: {
    getAllQueue() {
      let url = `/api/mail/queue_management`;
      requestService
        .GetFetch('ccp', url)
        .then((res) => {
          if (res.status == 200) {
            res.text().then((text) => {
              const data = text && JSON.parse(text);
              let userinfo = localStorage.getItem('userinfo');
              userinfo = JSON.parse(userinfo);
              // console.log('daa:', data.data)
              let myQueues = data.data.filter((obj) => {
                return (
                  obj.member.some((memberId) => memberId == userinfo.user_id) &&
                  obj.status
                );
              });
              // console.log('myQueues: ', myQueues)
              this.allQueue = myQueues;
            });
          }
        })
        .catch((err) => {
          console.log('err: ', err);
        });
    },
    setRealtimeDashboard(data) {
      let self = this;
      self.dashboardDetail.sumCountQueue = 0
      if (data.filterAllQueue != 0) {

        data.filterAllQueue.forEach((e) => {
          if (e !== undefined) {
            self.dashboardDetail.sumCountQueue += e.jobCount;
          }
        });
      }
      // console.log('data.filterAllQueue: ', data.filterAllQueue)
      self.dashboardDetail.countAllQueue = data.filterAllQueue == undefined ? [] : data.filterAllQueue;
      self.dashboardDetail.countQueue = data.count_queue;
      self.dashboardDetail.longestWaitTime = self.convertSecToTime(
        data.long_wait_time
      );
      self.bottomBar[0].case = data.open;
      self.bottomBar[1].case = data.pending;
      self.bottomBar[2].case = data.close;
      self.$root.$data.WorkerIO.port.postMessage([
        'updateLongTime',
        data.long_wait_time,
      ]);
    },
    setUpdateStatus(data) {
      switch (data.status) {
        case 'ready':
          this.statusColor = 'success';
          this.status = 'AVAILABLE';
          break;
        case 'acw':
          this.statusColor = 'warning';
          this.status = 'ACW';
          break;
        case 'acd':
          this.statusColor = 'primary';
          this.status = 'ACD';
          break;
        case 'aux':
          this.statusColor = 'light';
          this.status = 'AUX';
          break;
      }
      if (data.status == 'acd') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      this.$root.$data.WorkerIO.port.postMessage(['updateTime', data.status]);
    },
    onChangeStatus(status) {
      if (status == 'ready') {
        this.$root.$emit('getCountPending', 'jobData');
      } else {
        this.status = status;
        this.$root.$data.WorkerIO.port.postMessage(['changeStatus', status]);
      }
    },
    setRealtimeStatusTime(time) {
      this.statusTime = time;
    },
    setRealtimeStatusLongTime(time) {
      this.dashboardDetail.longestWaitTime = time;
    },
    /*setRealtimeQueue(data) {
      this.dashboardDetail.countQueue = data.jobInQueue;
      this.dashboardDetail.longestWaitTime = this.convertSecToTime(
        data.longestWaitTime
      );
    },*/
    convertSecToTime(sec) {
      var sec_num = parseInt(sec, 10); // don't forget the second param
      sec_num = sec_num / 1000;
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = parseInt(sec_num - hours * 3600 - minutes * 60);

      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return hours + ':' + minutes + ':' + seconds;
    },
  },
};
</script>

<style>
/* .card-body {
    padding: 30px !important;
  } */
</style>
